export default __webpack_public_path__ + "assets/access.e3c4a069.svg";